<template>
    <div class="basket-preview-wrapper h-100" :class="{ 'empty': !basketItems.length, 'open-hover': hover, 'open-right': !hover }">
        <div class="position-relative h-100">
            <div class="basket-preview d-flex flex-column flex-nowrap bg-white shadow w-100" style="z-index:99999;" v-if="showZubehoerIfExists === true && itemAdded == true">
              <header class="basket-preview-header border-bottom basket-preview-header-items">

                <button class="btn btn-primary btn-block" :disabled="loading" @click="getItemsAndBuy()">
                  {{ $translate('StockShop::Template.previewCrossBtnNext') }}
                  <template v-if="loading">
                    <i class="fa fa-spin fa-circle-o-notch ml-3"></i>
                  </template>
                </button>
                <button type="button" class="close" @click="showZubehoerIfExists = false;" :aria-label="$translate('Ceres::Template.closeIcon')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </header>
              <div class="basket-preview-content flex-fill text-left">
                <div class="p-3">
                  <div class="h3 mb-5 mt-2">{{ $translate('StockShop::Template.previewCrossHeader') }}</div>
                    <template v-if="previewItems.Accessory.length > 0">
                      <div class="h4 mt-2 font-weight-bold">
                        {{ $translate('StockShop::Template.previewCrossAccessory') }}
                      </div>
                      <div v-for="item in previewItems.Accessory">
                        <div class="form-check mt-3 mb-0 leftcheck">
                          <input type="checkbox" :id="item.data.item.id" class="form-check-input" v-model="item.selected">
                          <label :for="item.data.item.id" class="form-check-label">
                            <div class="d-flex">
                              <div style="height:50px; width:50px;" class="d-flex mr-3">
                                <img :src="item.data.images.all[0].urlMiddle" style="object-fit: cover;max-width: 100%;">
                              </div>
                              <div>
                                <div style="white-space: nowrap; overflow: hidden;text-overflow: ellipsis;width: 290px;">{{ item.data.texts.name1 }}</div>
                                <div class="font-weight-bold">{{ item.data.prices.default.price.formatted }}</div>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                    </template>
                </div>
              </div>
              <div class="p-3 border-top">
                <div class="basket-preview-footer">

                  <div class="row">
                    <div class="col-5">
                      <button class="btn btn-outline-primary btn-block" @click="showZubehoerIfExists = false">
                        {{ $translate('StockShop::Template.previewCrossBtnShop') }}
                      </button>
                    </div>
                    <div class="col-7">
                      <button class="btn btn-primary btn-block" @click="getItemsAndBuy()" :disabled="loading">
                        {{ $translate('StockShop::Template.previewCrossBtnNext') }}
                        <template v-if="loading">
                          <i class="fa fa-spin fa-circle-o-notch ml-3"></i>
                        </template>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="basket-preview d-flex flex-column flex-nowrap bg-white shadow w-100" >

                <header class="basket-preview-header border-bottom p-3">
                    <span class="h3 mb-0">{{ $translate("Ceres::Template.basketPreview") }}</span>
                    <button v-toggle-basket-preview type="button" class="close" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </header>

                <div v-if="basketNotifications.length > 0">
                    <div class="w-100 alert alert-danger" v-for="notification in basketNotifications" :key="notification.id">
                        <div>{{ notification.message }}</div>
                    </div>
                </div>

                <div class="basket-preview-content d-flex flex-fill">
                    <basket-list class="item-list d-flex flex-fill flex-nowrap flex-column overflow-auto px-3" :is-preview="true">
                        <template #before-basket-item>
                            <slot name="before-basket-item"></slot>
                        </template>
                        <template #after-basket-item>
                            <slot name="after-basket-item"></slot>
                        </template>
                    </basket-list>

                    <div class="totals d-flex flex-nowrap flex-column px-3 pt-3">

                        <shipping-country-select
                                v-if="showShippingCountrySelect"
                                :basket-select="true"
                                :open-basket-preview="true">
                        </shipping-country-select>
                        <hr>

                        <slot name="before-basket-totals"></slot>

                        <basket-totals>
                            <template #before-item-sum>
                                <slot name="before-item-sum"></slot>
                            </template>
                            <template #after-item-sum>
                                <slot name="after-item-sum"></slot>
                            </template>
                            <template #before-shipping-costs>
                                <slot name="before-shipping-costs"></slot>
                            </template>
                            <template #after-shipping-costs>
                                <slot name="after-shipping-costs"></slot>
                            </template>
                            <template #before-total-sum>
                                <slot name="before-total-sum"></slot>
                            </template>
                            <template #before-vat>
                                <slot name="before-vat"></slot>
                            </template>
                            <template #after-vat>
                                <slot name="after-vat"></slot>
                            </template>
                            <template #after-total-sum>
                                <slot name="after-total-sum"></slot>
                            </template>
                        </basket-totals>

                        <slot name="after-basket-totals"></slot>


                        <template v-if="mbw.amountReached">
                          <div class="basket-preview-footer d-flex pb-3">
                              <a v-waiting-animation-infinite :href="$ceres.urls.basket" rel="nofollow" class="btn btn-outline-primary btn-block" :title="$translate('Ceres::Template.basket')">
                                  <i class="fa fa-shopping-cart"></i>
                                  {{ $translate("Ceres::Template.basket") }}
                              </a>

                              <slot name="before-checkout-button"></slot>
                              <a v-waiting-animation-infinite :href="$ceres.urls.checkout" rel="nofollow" class="btn btn-primary btn-block" :title="$translate('Ceres::Template.basketCheckout')">
                                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                                  {{ $translate("Ceres::Template.basketCheckout") }}
                              </a>
                              <slot name="after-checkout-button"></slot>
                          </div>
                        </template>
                        <template v-else>
                          <p class="text-center my-2 pt-3 border-top" v-html="$translate('StockShop::Template.minOrderValue')"></p>
                          <div class="progress">
                            <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" :aria-valuemax="mbw.percentageReached" :style="'width:'+mbw.percentageReached+'%'"></div>
                          </div>
                          <p class="text-center my-2">
                            {{ $translate('StockShop::Template.minOrderValueToGet') }}
                            {{ mbw.restToReach | currency }}
                            {{ $translate('StockShop::Template.minOrderValueToGet2') }}
                          </p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="basket-preview-overlay" v-toggle-basket-preview></div>
    </div>
</template>

<script>
import ApiService from "../services/ApiService";
import { mapState } from "vuex";

export default {

    props:
    {
        showNetPrices:
        {
            type: Boolean,
            default: false
        }
    },
    data()
    {
      return {
        showZubehoerIfExists:false,
        loading:false,
        counter:0
      }
    },
    computed:
    {
        previewItems()
        {
          if(this.crossis != null)
          {
            let Similar   = this.addedKey(this.crossis.Similar);
            let Accessory = this.addedKey(this.crossis.Accessory);

            return {
              "Similar"   : Similar,
              "Accessory" : Accessory
            }
          }
          else
          {
            return {
              "Similar"   : [],
              "Accessory" : []
            }
          }
        },
        mbw()
        {
            let amountToReach     = App.MBW ?? 0;
            let restToReach       = amountToReach - this.basket.basketAmount;
            let percentageReached = (this.basket.basketAmount / amountToReach) * 100;
            let returnObj         =
            {
              "amountReached"     : this.basket.basketAmount > amountToReach ,
              "restToReach"       : restToReach,
              "percentageReached" : percentageReached
            }
            return returnObj;
        },
        hover()
        {
            return App.config.basket.previewType === 'hover';
        },

        showShippingCountrySelect()
        {
            return App.config.basket.showShippingCountrySelect;
        },

        ...mapState({
            basket: state => state.basket.data,
            basketItems: state => state.basket.items,
            basketNotifications: state => state.basket.basketNotifications,
            isBasketItemQuantityUpdate: state => state.basket.isBasketItemQuantityUpdate,
            crossis: state => state.stockshop.previewBox,
            itemAdded:state => state.stockshop.added
        })
    },

    /**
     * Bind to basket and bind the basket items
     */
    mounted()
    {
        if (App.config.basket.addItemToBasketConfirm === "preview")
        {
            ApiService.listen("AfterBasketItemAdd", data =>
            {
                this.show();
            });

            ApiService.listen("AfterBasketItemUpdate", data =>
            {
                if (!this.isBasketItemQuantityUpdate)
                {
                    this.show();
                }
            });
        }
        if(this.crossis != null)
        {
          if((this.crossis.Similar.length > 0 || this.crossis.Accessory.length > 0) && this.showZubehoerIfExists == false && this.counter == 0)
          {
            this.showZubehoerIfExists = true;
            this.counter = 1;
          }
        }
    },
    methods:
    {
        getItemsAndBuy()
        {
          this.loading = true;
          let ItemsToBuy = [];
          for(let i = 0; i < this.previewItems.Similar.length; i++)
          {
            if(this.previewItems.Similar[i].selected == true)
            {
              ItemsToBuy.push(this.previewItems.Similar[i])
            }
          }
          for(let i2 = 0; i2 < this.previewItems.Accessory.length; i2++)
          {
            if(this.previewItems.Accessory[i2].selected == true)
            {
              ItemsToBuy.push(this.previewItems.Accessory[i2])
            }
          }
          if(ItemsToBuy.length > 0)
          {
            for(let i3 = 0; i3 < ItemsToBuy.length; i3++)
            {
              let basketObj =
              {
                variationId: ItemsToBuy[i3].id,
                quantity: 1,
                totalOrderParamsMarkup: 0
              }
              if(i3 == ItemsToBuy.length-1)
              {
                this.$store.dispatch("addBasketItem", basketObj).then(() =>
                {
                  this.showZubehoerIfExists = false;
                  this.loading = false;
                });
              }
              else
              {
                this.$store.dispatch("addBasketItem", basketObj)
              }
            }
          }
          else
          {
            this.showZubehoerIfExists = false;
            this.loading = false;
          }
        },
        addedKey(itemList)
        {
          let itemListData = [];
          for(let i = 0; i < itemList.length; i++)
          {
            let data = JSON.parse(JSON.stringify(itemList[i]));
            data.selected = false;
            itemListData.push(data)
          }
          return itemListData;
        },
        show()
        {
            setTimeout(function()
            {
                document.body.classList.add("basket-open");
            }, 1);
        }
    }
}
</script>
